/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { Template__TeamSendsAdvisory } from '../../templates/team-sends-advisory';

@observer
export class Slide08 extends Component {
  componentDidMount() {
    // Do something
  }

  render() {
    const { children } = this.props;
    return (
      <div className={`slide-08`}>
        {children}
        <Template__TeamSendsAdvisory
          title={{
            text: ['UPDATE: Critical Apache', 'Zero-Day Vulnerability'],
            fontSize: 55,
            lineHeight: 40,
            letterSpacing: -4,
          }}
        />
      </div>
    );
  }
}
